import React from "react"
import { getLog } from "./helpers"


/**
 * Internal helper (not exported) shared by the two public wrappers below.
 *
 * example input : verify_address_type(myaddress, "bsv", "BitcoinSV")
 *   returns [true/false, message_to_print]
 *
 * send_address_is_bsv => can be used as a boolean, or for more detailed info:
 * 		0/false = problem
 * 		1 = valid
 * 		2 = unsure, see message associated
 */
function verify_address_type(myaddress, myprefix, myprefixname) {
	const function_id = "verify_address_type(): "
	const log = getLog(function_id)

	var message = ""
	if (myprefix.includes(":")) {
		myprefix = myprefix.split(":")[0] // remove ':' if included
	}

	if (myaddress.length === 0) {
		log("empty address")
		return [false, ""]
	}

	var res = myaddress.split(":")

	// if no prefix found, alert and return true
	if (res.length === 1) {
		log("no prefix found at all");
		message = <span>
			Avertissement: pas de préfixe "{myprefix}:" détecté,
			êtes vous certain qu'il s'agit d'une adresse {myprefixname} ?
		</span>
		return [2, message]
	}

	//if prefix found
	if (res.length === 2) {
		var prefix = res[0].toLowerCase()

		// wrong prefix
		if (prefix !== myprefix) {
			log("no '" + myprefix + ":' prefix found, found instead: " + prefix)
			message = <span>
				Erreur: Vous avez entré une adresse qui commence par "{prefix}:"
				au lieu de "{myprefix}:", il ne s'agit pas d'une addresse {myprefixname}
			</span>
			return [0, message]
		}
		// right prefix
		else {
			message = <span>
				☑ Votre adresse comporte bien le préfixe "{myprefix}:"
			</span>
			log(" found '" + myprefix + ":' prefix")
			return [1, message]
		}
	}

	message = "ERROR: verify_address_type(): wrong address type: " + myaddress
	log(message)

	return [0, message]
}


/**
 * BSV address verification.
 * Only accepts "bsv:" as a valid prefix.
 *
 * example of use:
 *		var [send_address_is_bsv, res_mess] = verify_address_type_bsv(myaddress)
 *
 * returns [0/1/2, message_to_print]  (see internal helper for codes)
 */
export function verify_address_type_bsv(myaddress) {
	return verify_address_type(myaddress, "bsv", "BitcoinSV")
}


/**
 * Token address verification (TokkenR / legacy Delphe).
 * Accepts BOTH "tokkenr:" and "delphe:" as valid prefixes.
 * Messages always reference "TokkenR" as the name, and echo the typed prefix
 * on success (so a user who pastes a legacy "delphe:" address still gets
 * a success message acknowledging the "delphe:" prefix).
 *
 * example of use:
 *		var [send_address_is_token, res_mess] = verify_address_type_token(myaddress)
 *
 * returns [0/1/2, message_to_print]  (see internal helper for codes)
 */
export function verify_address_type_token(myaddress) {
	const function_id = "verify_address_type_token(): "
	const log = getLog(function_id)

	// detect a legacy "delphe:" prefix (case-insensitive) and echo it on success
	if (myaddress && myaddress.toLowerCase().startsWith("delphe:")) {
		log("legacy 'delphe:' prefix accepted")
		return verify_address_type(myaddress, "delphe", "TokkenR")
	}

	// otherwise expect the new "tokkenr:" prefix
	return verify_address_type(myaddress, "tokkenr", "TokkenR")
}